import { ScrollDispatcher } from '@angular/cdk/scrolling';
import { Provider, Type, InjectionToken, Optional } from '@angular/core';

import { switchMap } from 'rxjs/operators';

import { filterBoolean } from '@core/common-legacy';
import type { IProsemirrorConfig } from '@core/prosemirror-legacy';
import { ScrollStream$ } from '@core/prosemirror-legacy/angular';

export const ProsemirrorConfig = new InjectionToken<Type<IProsemirrorConfig>>('Prosemirror config');
export const SCROLL_PROVIDER: Provider = {
  provide: ScrollStream$,
  useFactory: (scrollDispatcher?: ScrollDispatcher) => {
    if (!scrollDispatcher) throw new Error('You need to provide scroll dispatcher');

    return scrollDispatcher!.scrolled().pipe(
      filterBoolean,
      switchMap(scroll => scroll.elementScrolled()),
    );
  },
  deps: [[Optional, ScrollDispatcher]],
};
